import { timeZoneMap } from "@web-app/utils/helpers";

import DateTimeTz from "../DateTimeTz";

export default function ETAWithLabel({
  label,
  date,
  timezone,
}: {
  date: Date;
  label: string;
  timezone: keyof typeof timeZoneMap | undefined;
}) {
  return (
    <span className="flex items-center gap-1 text-[10px] lg:text-xs">
      {label}
      <DateTimeTz start={date} timezone={timezone} presentation="eta" />
    </span>
  );
}
